import {
  getStatusProps,
  ProposalStatus
} from "./proposalStatusRenderer";
import { ProposalCustomStatus, ProposalCustomStatusItenStatus } from "@/models/consignado/proposal.model";
import { formatErrorMessage } from "../formatErrorMessage";

const extrairValidadeLeilao = (customStatus: ProposalCustomStatus | null): string | null => {
  const expiracaoLance = customStatus?.acoes?.aguardar_validade_leilao;
  const mensagem = expiracaoLance?.status === ProposalCustomStatusItenStatus.AGUARDANDO
    ? expiracaoLance.mensagem
    : customStatus?.leilao?.validade_leilao?.mensagem;
  const [, dia, mes, hora, minuto] =
    mensagem?.match(/(?:previsto para|Validade do leilão:) (\d{2})\/(\d{2})\/\d{4} (\d{2}):(\d{2})/) ?? [];
  return dia ? `${dia}/${mes} - ${hora}:${minuto}` : null;
};

const parseCustomStatus = (customStatus: string | null | undefined): ProposalCustomStatus | null => {
  try {
    return customStatus ? JSON.parse(customStatus) : null;
  } catch (error) {
    console.warn("Erro ao fazer parse do customStatus:", error, customStatus);
    return null;
  }
};

// Formalização com a segurança de identidade concluída: falta só a averbação.
const ehAguardandoAverbacao = (status: ProposalStatus, proposalCustomStatus: ProposalCustomStatus | null): boolean =>
  status === ProposalStatus.PENDING_FORMALIZATION &&
  proposalCustomStatus?.formalizacao?.seguranca_identidade?.status === ProposalCustomStatusItenStatus.SUCESSO;

// Azul próprio do "Aguardando Averbação", diferente do secondary (formalização)
// e do blue.500 (validade do leilão).
const COR_AGUARDANDO_AVERBACAO = "cyan.700";

export const getProposalStatusColorConsignado = (
  status: ProposalStatus,
  customStatus: string | null | undefined
): string | undefined => {
  if (ehAguardandoAverbacao(status, parseCustomStatus(customStatus))) {
    return COR_AGUARDANDO_AVERBACAO;
  }
  return getStatusProps(status)?.color;
};

export const getProposalStatusAndCustomStatusConsignado = (
  status: ProposalStatus,
  customStatus: string | null | undefined
): string => {
  const proposalCustomStatus = parseCustomStatus(customStatus);

  // if (status === ProposalStatus.PENDING_USER_REVIEW && proposalCustomStatus?.confirmacao.criacao_proposta_bancarizadora.status === ProposalCustomStatusItenStatus.SUCESSO && proposalCustomStatus?.confirmacao.criacao_processo_seg_identidade.status === ProposalCustomStatusItenStatus.SUCESSO) {
  //   return "Corrigir Dados Bancários";
  // }

  if (status === ProposalStatus.PENDING_USER_REVIEW && proposalCustomStatus?.acoes?.corrigir_dados_bancarios && proposalCustomStatus?.acoes?.corrigir_dados_bancarios.status === ProposalCustomStatusItenStatus.AGUARDANDO) {
    return "Corrigir Dados Bancários";
  }

  if (ehAguardandoAverbacao(status, proposalCustomStatus)) {
    return "Aguardando Averbação";
  }

  if (status === ProposalStatus.PENDING_BANK_ANALYSIS && proposalCustomStatus?.acoes) {
 
    const {
      analisar_proposta_banco_valor,
      analisar_proposta_banco_documento,
      analisar_proposta_banco_multiplas,
      analisar_proposta_banco_biometria,
    } = proposalCustomStatus.acoes;

    const analysisItem =
      analisar_proposta_banco_valor?.status === ProposalCustomStatusItenStatus.AGUARDANDO
        ? analisar_proposta_banco_valor
        : analisar_proposta_banco_documento?.status === ProposalCustomStatusItenStatus.AGUARDANDO
          ? analisar_proposta_banco_documento
          : analisar_proposta_banco_multiplas?.status === ProposalCustomStatusItenStatus.AGUARDANDO
            ? analisar_proposta_banco_multiplas
            : analisar_proposta_banco_biometria?.status === ProposalCustomStatusItenStatus.AGUARDANDO
              ? analisar_proposta_banco_biometria
              : null;

    if (analysisItem) {
      // "Valor acima do limite" exibe label fixo em vez da mensagem do back
      if (analysisItem === analisar_proposta_banco_valor) {
        return "Análise banco";
      }

      const rawMessage =
     analysisItem.mensagem ?? "";

    const parts = rawMessage.split(": ");
    const cleanedMessage =
      parts.length > 1 ? parts.slice(1).join(": ") : rawMessage;
      return formatErrorMessage(cleanedMessage);

    }
  }

  if (status === ProposalStatus.AGUARDANDO_VALIDADE_LEILAO) {
    const validade = extrairValidadeLeilao(proposalCustomStatus);
    if (validade) {
      return `${getStatusProps(status).text} ${validade}`;
    }
  }

  return getStatusProps(status).text;
};

